"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../constants");
var _colors = require("../../birch/colors");
var birchVersion = {
  linkColor: _colors.FullPalette.GREEN_700,
  textDecoration: 'underline'
};
var Link = _styledComponents["default"].a.withConfig({
  displayName: "link__Link"
})(["font-family:Untitled Sans,sans-serif;font-size:14px;line-height:20px;color:", ";text-decoration:", ";", " &:hover{text-decoration:underline;}"], birchVersion.linkColor, birchVersion.textDecoration, (0, _constants.fontWeight)('normal'));
var _default = exports["default"] = Link;